import React from "react";
import {Layout} from "antd";
import Header from "../components/headerComponent/header";
import AddTeacher from "../components/structureComponent/addTeacherComponent";
import Footer from "../components/footerComponent/footer";

export default function AddTeacherPage() {
    return (
        <Layout>
            <Header/>
            <AddTeacher/>
            <Footer/>
        </Layout>
    );
};